<template>
    <search-select v-bind="$attrs" :options="options" :searchable="false" label="name" :loading="loading" placeholder="Выберите модель автомата" v-on="listeners" @input="$emit('input', $event)">
        <template slot="option" slot-scope="scope">
            <div class="d-flex justify-content-between align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
                <div />
            </div>
        </template>

        <template slot="singleLabel" slot-scope="scope">
            <div class="d-flex justify-content-between align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
                <div />
            </div>
        </template>
    </search-select>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import SearchSelect from '@/components/Select'

const state = new Vue.observable({
    loaded: false,
    loading: false,
    options: []
})

export const reset = () => {
    state.loaded = false
    state.loading = false
    state.options = []
}

export const fetchOptions = async _ => {
    if (state.loading || state.loaded) {
        return
    }

    state.loading = true

    try {
        const response = await axios.get('api/reference/bus_numbering_schemes')

        state.options = response.data
    } finally {
        state.loaded = true
        state.loading = false
    }
}

export default {
    components: {
        SearchSelect
    },

    inheritAttrs: false,
    props: {
        showRecipe: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        },

        options() {
            return state.options.filter(i => this.showRecipe || !i.is_composite)
        },

        loading() {
            return state.loading
        }
    },

    async created() {
        await fetchOptions()
    }
}
</script>
